import axios from "axios";
import { decryptData, encryptData } from "./decryption";
import { toast } from "react-toastify";
import { getSyncedTimestampSec, updateOffsetFromResponse } from "./timeSync";
import { createHmacSignature } from "./hmac";

// const REACT_APP_API_BASE_URL = "http://localhost:4000/api/v2";
const REACT_APP_API_BASE_URL = "https://chatbotapi.pimath.id.vn/api/v2";

// Tạo instance Axios
const apiClient = axios.create({
  baseURL: REACT_APP_API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

let isLoggingOut = false;

function logoutOnce(message) {
  if (isLoggingOut) return;
  isLoggingOut = true;

  if (message) toast.error(message);

  const currentPath = window.location.pathname + window.location.search;
  if (!currentPath.includes("/login") && currentPath !== "/chatbot-ai") {
    sessionStorage.setItem("redirectAfterLogin", currentPath);
  }

  localStorage.removeItem("user");

  if (!window.location.pathname.includes("/login")) {
    window.location.href = "/login";
  }
}

// Request Interceptor
apiClient.interceptors.request.use(
  (config) => {
    // ====== ENCRYPT BODY (GIỮ NGUYÊN CỦA BẠN) ======
    const skipEncryptRoutes = ["/upload/image", "/upload/file"];
    const shouldSkip = skipEncryptRoutes.some((r) => config.url?.includes(r));

    const isFormData =
      typeof FormData !== "undefined" && config.data instanceof FormData;

    let finalBody = config.data;

    if (
      !shouldSkip &&
      !isFormData &&
      config.data &&
      typeof config.data === "object"
    ) {
      finalBody = encryptData(config.data);
      config.data = finalBody;
    }

    // ====== HMAC SIGNATURE (KÝ TRÊN BODY ĐÃ ENCRYPT) ======
    const timestamp = getSyncedTimestampSec();
    const clientId = process.env.REACT_APP_HMAC_CLIENT_ID;
    const secret = process.env.REACT_APP_HMAC_SECRET;

    const path = new URL(config.url, config.baseURL).pathname;
    const fullPath = `/api/v2${path}`;

    const signature = createHmacSignature({
      method: config.method,
      url: fullPath,
      timestamp,
      body: finalBody,
      secret,
    });

    config.headers["x-client-id"] = clientId;
    config.headers["x-timestamp"] = timestamp;
    config.headers["x-signature"] = signature;
    return config;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => {
    updateOffsetFromResponse(response);
    return decryptData(response.data);
  },
  async (error) => {
    try {
      if (error?.response?.data) {
        error.response.data = decryptData(error.response.data);
      }
    } catch (e) {
      console.error("Decrypt error response failed:", e);
    }

    const res = error?.response;
    if (!res) return Promise.reject(error);

    updateOffsetFromResponse(res);

    const status = res.status;
    const message = String(res.data?.message || "");
    if (status === 401) {
      logoutOnce(message || "Phiên đăng nhập đã hết hạn");
    }

    return Promise.reject(error);
  },
);

// Các hàm HTTP tiện dụng
export const get = (url, config = {}) => apiClient.get(url, config);
export const post = (url, data, config = {}) =>
  apiClient.post(url, data, config);
export const put = (url, data, config = {}) => apiClient.put(url, data, config);
export const del = (url, config = {}) => apiClient.delete(url, config);
export const patch = (url, data, config = {}) =>
  apiClient.patch(url, data, config);

export default apiClient;
